var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonActions = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M18 16.025V5.997A2.003 2.003 0 0016.006 4H5.994C4.898 4 4 4.9 4 5.997v10.006C4 17.1 4.898 18 5.994 18h9.99A1.975 1.975 0 0018 16.025z", fill: fills.light }),
        React.createElement("path", { d: "M16.722 35.983c-2.8 0-5.039-2.485-4.759-5.436.259-2.553 2.541-4.417 5.039-4.417h13.803c4.586 0 8.7-3.44 9.151-8.166C40.473 12.57 36.34 8 31.192 8h-8.247c-1.077 0-1.96.91-1.96 2.02 0 1.109.883 2.019 1.96 2.019h7.967c2.541 0 4.867 1.886 5.125 4.482.302 2.996-1.98 5.526-4.845 5.526H17.11c-4.544 0-8.614 3.418-9.066 8.078C7.527 35.473 11.62 40 16.722 40h8.333c1.077 0 1.96-.91 1.96-2.02 0-1.109-.883-2.019-1.96-2.019h-8.333v.022z", fill: fills.dark }),
        React.createElement("path", { d: "M44.08 42.031v-9.864c0-1.082-.902-1.97-2.004-1.97h-10.07c-1.102 0-2.006.888-2.006 1.97v9.864c0 1.082.904 1.969 2.005 1.969h10.049c1.123 0 2.027-.887 2.027-1.969z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
